import { sbEditable } from '@storyblok/storyblok-editable'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import React from 'react'

export const BlogRTE = ({ blok }) => (
  <div {...sbEditable(blok)} className="prose">
    {renderRichtext(blok.text)}
  </div>
)
